export default __webpack_public_path__ + "assets/audio/1-50363205_clip.mp3";